import React   from 'react' ;
import PageCh15_t1 from './pageCh15_t1';
import PageCh15_t2 from './pageCh15_t2';
const   PageCh15 = ()=>{
     
       
    return (
      <>  <hr/> 
      <h1 className="m-2" >PageCh15 (chapter 15 Custom Hooks)</h1>
       <PageCh15_t1 />    
       <PageCh15_t2 />    
      </>
    )
     
} 
export default PageCh15
